import { Button, Grid, makeStyles } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import { Form, Formik } from "formik";
import React, { useRef } from "react";
import { MatchStatusOptions } from "../../Base/AdoptionConstants";
import FormikSelectField from "../../Base/Components/FormikSelectField";
import FormikTextField from "../../Base/Components/FormikTextField";
const useStyles = makeStyles((theme) => ({
  formGroup: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

export default function MatchSearchCriteria({ searchCriteria, setSearchCriteria }) {
  const classes = useStyles();
  const basicCriteriaFormikRef = useRef();

  React.useEffect(() => {
    // Keep the basic & advanced search criteria in sync when search criteria changes
    const formValues = getFormValuesFromSearchCriteria(searchCriteria);
    basicCriteriaFormikRef.current?.setValues(formValues);
  }, [searchCriteria]);

  function getFormValuesFromSearchCriteria(criteria) {
    const formValues = {
      matchId: criteria?.matchId ?? "",
      matchStatus: criteria?.matchStatus ?? [],
    };
    return formValues;
  }

  function handleSubmit(values) {
    const specifiedSearchCriteria = {};
    for (const searchCriteria in values) {
      const value = values[searchCriteria];
      // Only search on the values that are populated (e.g, avoid searching where last name is blank string)
      if (value !== null && value !== "" && values !== undefined) {
        specifiedSearchCriteria[searchCriteria] = value;
      }
    }

    setSearchCriteria(specifiedSearchCriteria);
    // setAdvancedSearchOpen(false);
    return Promise.resolve();
  }

  return (
    <Formik initialValues={getFormValuesFromSearchCriteria()} onSubmit={handleSubmit} innerRef={basicCriteriaFormikRef}>
      {(formik) => (
        <Form onSubmit={formik.handleSubmit}>
          <Grid contianer>
            <Grid item md={6} className={classes.formGroup}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <FormikTextField name="matchId" fullWidth label="ID" size="small" />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormikSelectField
                    name="matchStatus"
                    options={MatchStatusOptions}
                    getValueForOption={(option) => option.value}
                    getLabelForOption={(option) => option.label}
                    label="Match Status"
                    idPrefix="advanced"
                    multiple={true}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={12} className={classes.formGroup}>
              <Grid container justify="flex-end" alignItems="flex-end" style={{ height: "100%", paddingBottom: 8 }}>
                <Button variant="contained" color="primary" type="submit">
                  <Search /> Search
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
}
